"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var badges = {
    all_in_one: {
        notEarnIconName: 'badgeNotEarnAllInOne',
        earnIconName: 'allInOneEarn',
        descriptionKey: 'AllInOneBadge'
    },
    certified: {
        notEarnIconName: 'certifiedNotEarn',
        earnIconName: 'certifiedEarn',
        descriptionKey: 'badgeGame'
    },
    share: { notEarnIconName: 'shareNotEarn', earnIconName: 'shareEarn', descriptionKey: 'ShareBadge' },
    streak: { notEarnIconName: 'streakNotEarn', earnIconName: 'streakEarn', descriptionKey: 'StreakBadge' },
    multilingual: {
        notEarnIconName: 'multilanguageNotEarn',
        earnIconName: 'multilanguageEarn',
        descriptionKey: 'badgeMultilanguage'
    },
    classical: {
        notEarnIconName: 'classicalNotEarn',
        earnIconName: 'classicalEarn',
        descriptionKey: 'badgeClassical'
    },
    god: { notEarnIconName: 'godNotEarn', earnIconName: 'godEarn', descriptionKey: 'badgeGod' },
    mobility: { notEarnIconName: 'mobileNotEarn', earnIconName: 'mobileEarn', descriptionKey: 'badgeMobile' },
    embedded: { notEarnIconName: 'embeddedNotEarn', earnIconName: 'embeddedEarn', descriptionKey: 'badgeC' },
    webbed: {
        notEarnIconName: 'webbedNotEarn',
        earnIconName: 'webbedEarn',
        descriptionKey: 'badgeWebbed'
    },
    game: {
        notEarnIconName: 'gameNotEarn',
        earnIconName: 'gameEarn',
        descriptionKey: 'badgeGame'
    }
};
exports.default = badges;
